/**
 * Topic Service
 * API calls for topic management
 */

import api from '../utils/api.js';

export const topicService = {
  /**
   * Get all topics
   */
  getAllTopics: async () => {
    return api.get('/decks/topics');
  },
};
